/**!
 * Created by Leonardo Cheslacki on 29/01/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

// import PropTypes from 'prop-types';

import HelpersController from './HelpersController';

import WithType from './WithType';

let _this = {};

/**
 *
 */
class HelpersElement extends HelpersController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            json: {}
        };

        _this = this;
    };

    /**
     *
     * @param name
     * @param value
     */
    setInputJson = (name, value) => {
        if (this.checkArrayNamedInput(name)) {
            let array = this.extractArrayNamedInput(name);

            if (this.isArrayIf(array)) {
                let
                    object = value,
                    last = array[array.length - 1];

                array.reverse();

                if (this.checkArrayInput(last)) {
                    array.shift();

                    for (let i = 0; i < array.length; i++) {
                        array[i] = this.ArrayNamedToNameInput(array[i]);

                        if (!this.isObject(object)) {
                            object = [{[array[i]]: object}];
                        } else {
                            object = {[array[i]]: object};
                        }
                    }

                    this.setStates({json: object})
                } else {
                    for (let i = 0; i < array.length; i++) {
                        array[i] = this.ArrayNamedToNameInput(array[i]);
                        object = {[array[i]]: object};
                    }

                    this.setStates({json: object})
                }
            }
        } else {
            this.setStates({json: {[name]: value}})
        }
    };

    /**
     *
     * @param element
     * @returns {(function(*): (*|undefined))|*}
     */
    wantValue = (element) => () => {
        if (this.isElement(element)) {
            let value = this.inElement(element, 'value') && element.value;
            return !this.isEmpty(value) ? value : '';
        }
    };

    /**
     *
     * @param element
     * @returns {(function(*): (*|undefined))|*}
     */
    wantAttribute = (element) => (name) => {
        if (this.isElement(element)) {
            let value = element.getAttribute(name);
            return !this.isEmpty(value) && value;
        }
    };

    /**
     *
     * @param elements
     * @returns {(function(): void)|*}
     */
    wantJson = (elements) => () => {
        this.setStates({json: {}});

        if (this.isElement(elements)) {
            let value = this.wantAttribute(elements)('name');
            !this.isEmpty(value) && this.setInputJson(value, this.wantValue(elements)());
        } else if (this.isArrayIf(elements)) {
            elements.map((item) => {
                let value = this.wantAttribute(item)('name');
                !this.isEmpty(value) && this.setInputJson(value, this.wantValue(item)());
            });
        }

        return this.getState('json');
    };

    /**
     *
     * @param element
     * @returns {(function(null=): (*|undefined))|*}
     */
    wantInputs = (element) => (name = null) => {
        if (this.isElement(element)) {
            let array = this.elementToArray(element.querySelectorAll('input, select, textarea'));

            if (!this.isEmpty(name)) {
                let item = array.filter((item) => {
                    return (this.wantAttribute(item)('name') === name);
                });

                if (this.isArrayIf(item)) {
                    let input = item[0];
                    input.wantJson = this.wantJson(input);
                    return this.isElement(input) && input;
                }
            } else if (this.isArrayIf(array)) {
                array.wantJson = this.wantJson(array);
                return array;
            }
        }
    };

    /**
     *
     * @param element
     */
    setWant = (element) => {
        element.wantAttribute = this.wantAttribute(element);
        element.wantInputs = this.wantInputs(element);
    };

    /**
     *
     * @param name
     * @returns {HTMLElement}
     */
    getById = (name) => {
        const {document} = this.props;
        let element = document.getElementById(name);
        if (this.isElement(element)) {
            element.hasChildNodes() && this.setWant(element);
            return element;
        }
    };

    /**
     *
     * @param name
     * @returns {*}
     */
    getByClass = (name) => {
        const {document} = this.props;
        let array = this.elementToArray(document.getElementsByClassName(name));
        if (this.isArrayIf(array)) {
            let element = array[0];
            if (this.isElement(element)) {
                element.hasChildNodes() && this.setWant(element);
                return element;
            }
        }
    };

    /**
     *
     * @param name
     * @returns {*}
     */
    getAllClass = (name) => {
        const {document} = this.props;
        let array = this.elementToArray(document.getElementsByClassName(name));
        if (this.isArrayIf(array)) {
            for(let property of array){
                property.hasChildNodes() && this.setWant(property);
            }
            return array;
        }
    };
}

/**
 *
 * @type {{}}
 */
HelpersElement.propTypes = {};

/**
 *
 * @type {{}}
 */
HelpersElement.defaultProps = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(HelpersElement, {className: 'HelpersElement'});
